class BfvStageNewsCompact {
  constructor(options = {}) {
    this.$root = options.element;
    this.$newsCompact = this.$root.querySelector('.js-news-compact');
    this.$loadMoreButton = this.$newsCompact.querySelector('.js-load-more-button');
  }

  init() {
    this.bindClickEvents();
  }

  bindClickEvents() {
    this.$loadMoreButton.addEventListener('click', () => {
      this.$newsCompact.classList.remove('bfv-news-compact--half-hidden');
    });
  }
}

export default BfvStageNewsCompact;



// WEBPACK FOOTER //
// ./src/javascript/main/BfvNewsCompact/index.js